import { Navigate } from "react-router-dom"
import { useAdminAuth } from "@/contexts/AdminAuthContext"

export default function AdminProtectedRoute({
                                                children,
                                            }: {
    children: React.ReactNode
}) {
    const { isAdminLoggedIn, isLoading } = useAdminAuth()

    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-slate-50">
                <div className="text-sm text-slate-500">관리자 인증 확인 중...</div>
            </div>
        )
    }

    if (!isAdminLoggedIn) {
        return <Navigate to="/admin/login" replace />
    }

    return <>{children}</>
}